import * as ActionTypes from '../action-types';

const initialStateFabricModalInfo = {
  img: '',
  name: '',
  composition: '',
  durability: '',
  care: '',
  details: '',
  origin: '',
  patternRepeat: '',
  pattern: ''
};

const initialState = {
  loginModalOpen: false,
  customerOverlayNav: false,
  fabricModal: { info: initialStateFabricModalInfo, isOpen: false },
  isGlobalCartOpen: false,
  globalCart: { isOpen: false, skuAdded: null, productData: null },
  photoSidebar: { isOpen: false, photoId: null }
};

const AddToCart = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.SET_OPEN_LOGIN_MODAL:
      return { ...state, loginModalOpen: action.payload };
    case ActionTypes.SET_CUSTOMER_OVERLAY_NAV:
      return { ...state, customerOverlayNav: action.payload };
    case ActionTypes.SET_OPEN_FABRIC_MODAL:
      return {
        ...state,
        fabricModal: { ...state.fabricModal, isOpen: action.payload }
      };
    case ActionTypes.SET_FABRIC_MODAL_DATA:
      return {
        ...state,
        fabricModal: { ...state.fabricModal, info: action.payload }
      };
    case ActionTypes.TOGGLE_GLOBAL_CART:
      const newState = { ...state };
      return {
        ...newState,
        globalCart: {
          ...newState.globalCart,
          isOpen: !newState.globalCart.isOpen
        }
      };

    case ActionTypes.HANDLE_GLOBAL_CART:
      const nextState = { ...state };
      return {
        ...nextState,
        globalCart: {
          ...nextState.globalCart,
          skuAdded: action.payload?.sku ? action.payload?.sku : null,
          productData: action.payload?.productData
            ? action.payload?.productData
            : null,
          isOpen: !nextState.globalCart.isOpen
        }
      };

    case ActionTypes.HANDLE_PHOTO_SIDEBAR:
      const newStatePhoto = { ...state };

      return {
        ...newStatePhoto,
        photoSidebar: {
          ...newStatePhoto.globalCart,
          photoId: action.payload?.photoId ? action.payload?.photoId : null,
          isOpen: !newStatePhoto.photoSidebar.isOpen
        }
      };

    default:
      return state;
  }
};

export default AddToCart;
